import axios from "axios";
import { useAuth } from "../context/AuthContext"; // path to your Zustand auth store
import { BASE_URL } from "./urls";
import { toast } from "sonner";

const api = axios.create({
  baseURL: BASE_URL, // assuming you're using Vite, adjust if needed
  withCredentials: true, // VERY important for refresh-token cookie
});

// REQUEST INTERCEPTOR
api.interceptors.request.use(
  (config) => {
    const { accessToken } = useAuth.getState();
    if (accessToken && accessToken !== "") {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// RESPONSE INTERCEPTOR
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const res = await axios.get(
          `${BASE_URL}/user/generate-new-refresh-token`,
          { withCredentials: true }
        );

        const newAccessToken = res.data.data.accessToken;

        // Update Zustand store
        useAuth.getState().setAuth(newAccessToken);

        // Update Authorization header in original request
        originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;

        // Retry original request
        return api(originalRequest);
      } catch (refreshError) {
        console.error("Refresh token invalid:", refreshError);
        toast.error("Please Login");
        window.location.href = "/login"; // logout user
      }
    }

    return Promise.reject(error);
  }
);

export default api;
